<template>
  <div class="py-2 px-4">
    <div class="rounded-md bg-green-50 p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <icon set="solid" name="check-circle" class="h-5 w-5 text-green-400" />
        </div>
        <div class="ml-3">
          <h3 class="text-sm font-medium text-green-800">
            <slot name="header">{{ header }}</slot>
          </h3>
          <div class="mt-2 text-sm text-green-700">
            <slot>
              <p>
                {{ body }}
              </p>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertSuccess",
  props: {
    header: {
      type: String,
      default: ''
    },
    body: {
      type: String,
      default: ''
    }
  },
};
</script>
